import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const ConsAIAssistantContext = createContext(null);

export function useConsAIAssistant() {
  return useContext(ConsAIAssistantContext);
}

export function ConsAIAssistantProvider({ children }) {
  const [panelOpen, setPanelOpen] = useState(false);
  const [tab, setTab] = useState("ask");
  const [askCount, setAskCount] = useState(0);
  const [guideNudge, setGuideNudge] = useState(false);

  const registerAsk = useCallback(() => {
    setAskCount((count) => count + 1);
  }, []);

  const unregisterAsk = useCallback(() => {
    setAskCount((count) => Math.max(0, count - 1));
  }, []);

  const openPanel = useCallback((nextTab) => {
    if (nextTab) setTab(nextTab);
    setPanelOpen(true);
  }, []);

  const value = useMemo(
    () => ({
      panelOpen,
      setPanelOpen,
      tab,
      setTab,
      hasAsk: askCount > 0,
      registerAsk,
      unregisterAsk,
      guideNudge,
      setGuideNudge,
      openPanel,
    }),
    [
      panelOpen,
      tab,
      askCount,
      guideNudge,
      registerAsk,
      unregisterAsk,
      openPanel,
    ],
  );

  return (
    <ConsAIAssistantContext.Provider value={value}>
      {children}
    </ConsAIAssistantContext.Provider>
  );
}
